const hostPath =
  process.env.NODE_ENV === "production"
    ? "https://us-central1-produccion-elco.cloudfunctions.net"
    : "http://localhost:5000/produccion-elco/us-central1"; /*  "http://localhost:5001/fir-tutorial-341bb/us-central1/api";*/

module.exports = {
  hostPath,
};
